import styled from "styled-components";

export const StyledWishlist = styled.div`

`;